export const getBerthManagementsEndpoint = (
  tenantId: string,
  warehouseId: string,
  bookingDate: string,
  berthId?: string,
  includedType: number = 0
) =>
  `/berths/berth_managements?tenant_id=${tenantId}&warehouse_id=${warehouseId}&included_type=${includedType}&booking_date=${bookingDate}${berthId ? `&berth_id=${berthId}` : ''}` as const
